import axios, { AxiosResponse } from 'axios'

export const getExchangesOfferedByMe = (includes: string[] = []): Promise<AxiosResponse> => axios.get(
    `${process.env.REACT_APP_API_URL}/me/exchanges/offered-by-me`,
    {
        params: {
            include: includes.join(','),
            orderBy: JSON.stringify({ start: 'ASC' }),
        },
    },
)

export const getExchangesOfferedForMe = (includes: string[] = []): Promise<AxiosResponse> => axios.get(
    `${process.env.REACT_APP_API_URL}/me/exchanges/offered-to-me`,
    {
        params: {
            include: includes.join(','),
            orderBy: JSON.stringify({ start: 'ASC' }),
        },
    },
)

export const getExchange = (includes: string[], exchangeUuid: string): Promise<AxiosResponse> => axios.get(
    `${process.env.REACT_APP_API_URL}/exchanges/${exchangeUuid}`,
    {
        params: {
            include: includes.join(','),
        },
    },
)
